import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface ActionButtonProps extends Omit<ButtonProps, 'variant' | 'size'> {
  /** Whether this action is currently active/toggled on */
  active?: boolean;
  /** Color when active - defaults to foreground */
  activeColor?: string;
}

/**
 * Shared icon button for link actions (favorite, read status, more menu, etc.)
 * Used in both LinkCard and LinkDetail for consistent styling.
 */
export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ className, active, activeColor, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="icon"
        className={cn(
          'rounded-full text-muted-foreground/70 hover:text-foreground hover:bg-muted/50 [&_svg]:size-5',
          active && activeColor,
          className
        )}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

ActionButton.displayName = 'ActionButton';
